<aw-bottom-sheet [title]="label()" [titleId]="titleId" (closed)="finish()">
  <aw-content-block [label]="commonTranslations.actions">
    @for (item of actions(); track item.id) {
      @let isFavorite = item.selectedTone === 'favorite';
      <aw-content-item
        [attr.data-action]="item.id"
        [label]="item.label"
        [icon]="item.iconTemplate || isFavorite ? undefined : item.icon"
        [tone]="item.variant === 'destructive' ? 'danger' : 'default'"
        [control]="item.selected === undefined || isFavorite ? 'none' : 'check'"
        [selected]="!isFavorite && !!item.selected"
        [disabled]="item.disabled || false"
        (pressed)="select(item)"
      >
        @if (isFavorite) {
          <i
            leading
            class="aw-2-icn action-icon action-icon--favorite"
            aria-hidden="true"
            [class.action-icon--selected]="item.selected"
            [awIcon]="item.selected ? 'star-filled' : 'star'"
          ></i>
        } @else if (item.iconTemplate; as template) {
          <span leading class="action-icon" aria-hidden="true">
            <ng-container [ngTemplateOutlet]="template" />
          </span>
        }
      </aw-content-item>
    }
  </aw-content-block>
</aw-bottom-sheet>
